module.exports = __webpack_public_path__ + "static/media/SFMono-RegularItalic.8eddf7ad.ttf";